import Server from './../../libs/server'

const state = {
    messageList: [],
    messageCount: 0,
    body: null
};

const actions = {
    getMessageList({commit, dispatch}) {
        return new Promise((resolve, reject) => {
            Server.getMessageList((err, data) => {
                if (err) {
                    console.error(err.message);
                    reject(err.message);
                }
                else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        commit('GET_MESSAGES_LIST', data.messages);
                        resolve();
                    }
                }
            });
        });
    },
    getMessage({commit, dispatch}, id) {
        return new Promise((resolve, reject) => {
            Server.getMessage(id, (err, data) => {
                if (err) {
                    console.error(err.message);
                }
                else {
                    if (data.error) {
                        reject(data.error);
                    }
                    else {
                        commit('GET_MESSAGE_BODY', data.message.body);
                        resolve();
                    }
                }
            });
        });
    },
    setMessageCount({commit, dispatch}, messageCount) {
        commit('SET_MESSAGE_COUNT', messageCount);
    }
};

const mutations = {
    GET_MESSAGES_LIST(state, messages) {
        state.messageList = messages;
    },
    GET_MESSAGE_BODY(state, body) {
        state.body = body;
    },
    SET_MESSAGE_COUNT(state, messageCount) {
        state.messageCount = messageCount;
    }
};

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/messages.js